var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlockInsightsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "UnlockInsights_icon_svg__a",
    d: "M0 0h25.95v6.436H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "UnlockInsights_icon_svg__c",
    d: "M0 0h6.243v31.24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "UnlockInsights_icon_svg__e",
    d: "M0 0h5.79v25.256H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.087 30.385c0 11.502-9.324 20.826-20.826 20.826S9.435 41.887 9.435 30.385 18.76 9.56 30.261 9.56s20.826 9.323 20.826 20.825",
    fill: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.681)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "UnlockInsights_icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#UnlockInsights_icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.042 6.436a1.04 1.04 0 01-.55-1.925A29.917 29.917 0 0116.318 0c3.034 0 6.028.452 8.9 1.342a1.04 1.04 0 01-.617 1.99 27.914 27.914 0 00-8.283-1.25A27.847 27.847 0 001.591 6.28c-.17.106-.361.157-.549.157",
    fill: "#999",
    mask: "url(#UnlockInsights_icon_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14.764)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "UnlockInsights_icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#UnlockInsights_icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.203 31.24a1.04 1.04 0 01-.891-.502A29.946 29.946 0 010 15.236C0 10.082 1.33 4.998 3.845.532A1.041 1.041 0 115.66 1.555a27.927 27.927 0 00-3.577 13.68 27.87 27.87 0 004.01 14.425 1.04 1.04 0 01-.89 1.58",
    fill: "#999",
    mask: "url(#UnlockInsights_icon_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30 60a29.96 29.96 0 01-9.441-1.516 1.04 1.04 0 11.655-1.976c2.824.935 5.78 1.41 8.786 1.41 3.99 0 7.843-.824 11.451-2.45a1.043 1.043 0 01.855 1.9A29.793 29.793 0 0130 60",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.21 19.972)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "UnlockInsights_icon_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#UnlockInsights_icon_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.041 25.256a1.04 1.04 0 01-.907-1.552 27.932 27.932 0 003.574-13.676c0-2.963-.462-5.877-1.37-8.664A1.042 1.042 0 114.316.718a29.99 29.99 0 011.473 9.31 30.025 30.025 0 01-3.84 14.697c-.192.34-.545.53-.909.53",
    fill: "#999",
    mask: "url(#UnlockInsights_icon_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A27F",
    d: "M16.334 12.13l-5.89 5.89 33.133 33.134 5.891-5.891z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.354 17.459L43.578 49.68l4.417-4.418-32.223-32.222-6.628-2.209 2.21 6.627zm32.224 34.736c-.276 0-.542-.11-.737-.305L9.708 18.757a1.04 1.04 0 01-.252-.407L6.51 9.515a1.04 1.04 0 011.317-1.317l8.836 2.945c.153.05.292.137.407.251l33.133 33.133a1.042 1.042 0 010 1.472l-5.89 5.89a1.04 1.04 0 01-.736.306z",
    fill: "#EE4900"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE4900",
    d: "M45.787 48.944L12.653 15.812l1.472-1.473L47.26 47.472z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.995 55.75c-.834 0-1.619-.324-2.21-.915l-2.944-2.945 1.472-1.472 2.946 2.945c.394.394 1.08.394 1.473 0l2.945-2.945a1.044 1.044 0 000-1.473L48.731 46l1.472-1.473 2.946 2.945a3.13 3.13 0 010 4.418l-2.946 2.945a3.1 3.1 0 01-2.209.915",
    fill: "#EE4900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.734 22.073c3.345 1.772 7.585 1.252 10.4-1.565A8.852 8.852 0 0039.617 7.991a8.854 8.854 0 00-1.564 10.4L7.588 48.856l3.682 3.682 1.472-1.472 3.681 3.68 2.946-2.944-3.682-3.682 2.946-2.945 3.68 3.681 2.947-2.944-3.682-3.682 20.156-20.157z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.742 50.024c.267 0 .533.102.736.305l2.946 2.945 1.472-1.472-2.944-2.945a1.04 1.04 0 010-1.472l2.944-2.946a1.04 1.04 0 011.473 0l2.945 2.946 1.473-1.474-2.946-2.944a1.045 1.045 0 010-1.473l20.156-20.157c.323-.323.82-.398 1.225-.184a7.769 7.769 0 009.176-1.381 7.757 7.757 0 002.287-5.521 7.758 7.758 0 00-2.287-5.523c-3.045-3.045-8-3.045-11.044 0a7.769 7.769 0 00-1.38 9.177c.213.404.139.9-.185 1.223L9.06 48.858l2.21 2.208.736-.737c.203-.203.47-.305.736-.305m3.682 5.764c-.267 0-.533-.102-.736-.305l-2.946-2.945-.736.736a1.04 1.04 0 01-1.473 0l-3.682-3.68a1.043 1.043 0 010-1.473l29.944-29.943A9.836 9.836 0 0138.88 7.256c3.857-3.858 10.132-3.858 13.99 0a9.823 9.823 0 012.897 6.995 9.822 9.822 0 01-2.898 6.993 9.832 9.832 0 01-10.922 2.087l-18.898 18.9 2.946 2.944a1.04 1.04 0 010 1.472l-2.946 2.946a1.041 1.041 0 01-1.473 0l-2.944-2.946-1.473 1.474 2.945 2.945a1.037 1.037 0 010 1.472l-2.945 2.945a1.04 1.04 0 01-.736.305",
    fill: "#EE4900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.876 11.648c-.667 0-1.333.253-1.841.76a2.61 2.61 0 000 3.683c.984.984 2.699.984 3.682 0a2.608 2.608 0 000-3.683 2.596 2.596 0 00-1.841-.76m0 7.288a4.655 4.655 0 01-3.314-1.372 4.692 4.692 0 010-6.628 4.692 4.692 0 016.627 0 4.692 4.692 0 010 6.628 4.653 4.653 0 01-3.313 1.372",
    fill: "#EE4900"
  }))));
}
export default SvgUnlockInsightsIcon;